export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8901.478bef5a.jpg";